/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-max-depth */
import { Grid, Modal, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import ButtonLink from '../../components/elements/ButtonLink';
import SelectBox from '../../components/fields/SelectBox';
import { AppContext } from '../../contexts';
import { deleteFaqById, fetchCategory, fetchPangkalanFaq } from './actions';
import FormDetail from './FormDetail';
import GridCol from './Grid';
import styles from './styles.scoped.css';

export default function Pangkalan() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useContext(AppContext);
  const [category, setCategory] = useState('all');
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [item, setItem] = useState({});

  const {
    dataCategories,
    dataPangkalanFaq: dataFaq,
    isLoadingDeleteFaq,
  } = useSelector((s) => s.faq);

  useEffect(() => {
    setBreadcrumbs(['Pengaturan FAQ']);
    dispatch(fetchCategory());
    dispatch(fetchPangkalanFaq({ category }));
  },[]);

  useEffect(() => {
    if(!isLoadingDeleteFaq && category){
      dispatch(fetchPangkalanFaq({ category }));
    }
  },[isLoadingDeleteFaq, category]);

  const onDeleteClick = (item) => {
    setItem(item);
    setOpenConfirmModal(true);
  };

  const rediectUpdate = (item) =>
    navigate(`/faq/edit?faqId=${item.faqId}`);

  const onDelete = (id) => {
    setOpenConfirmModal(false);
    dispatch(deleteFaqById(id));
  };

  useEffect(() => {
    dispatch(fetchCategory());
    dispatch(fetchPangkalanFaq({ category }));
  }, [isLoadingDeleteFaq]);

  const showDetail = (item) => {
    setOpenModal(true);
    setItem(item);
  };

  return (
    <>
      <div className={styles.filterContainer}>
        <div className={styles.filter}>
          <label className={styles.label}>Kategori</label>
          <SelectBox
            className={styles.filterComponent}
            data={[
              { value: 'all', label: 'Semua Kategori' },
              ...dataCategories
            ]}
            eventName="filter_faq_by_category"
            input={{ value: category ? category : true }}
            label={''}
            onChangeSelect={(e) => setCategory(e)}
            searchable={false}
            valueForm={category} />
        </div>
        <ButtonLink className={styles.updatePriceBtn} to={'/faq/set'} type="primary" >
            Buat FAQ
        </ButtonLink>
      </div>
      <hr className={styles.separatorFaq} />
      <div className={styles.listCategories}>
        {dataFaq.map((data,idx) => {
          let key =  Object.keys(data)[0];
          return(
            <div key={idx + key}><h4>{Object.keys(data)[0]}</h4>
              <Grid>
                {data[key].map((item) => {
                  return(
                    <GridCol
                      item={item}
                      key={item.faqId}
                      onClickDelete={() => onDeleteClick(item)}
                      onClickDetail={() => showDetail(item)}
                      onClickUpdate={() => rediectUpdate(item)}
                      span={4} />
                  );
                }
                )}
              </Grid>
            </div>
          );}
        )}
      </div>
      <Modal
        centered={true}
        onClose={() => setOpenModal(false)}
        opened={openModal}
        overflow="inside"
        size="xl"
        title={'Detail FAQ Pangkalan'}
      >
        <FormDetail item={item} onCloseModal={() => setOpenModal(false)} type={'detail'}/>
      </Modal>
      <Modal
        centered={true}
        opened={openConfirmModal} withCloseButton={false}>
        <div className={styles.row}>
          <Text className={styles.textTitle}>Yakin ingin hapus FAQ ini?</Text>
        </div>
        <div className={styles['form-action']}>
          <Button
            onClick={()=> setOpenConfirmModal(false)}
            outlined={true}
          >
              Batal
          </Button>
          <Button onClick={() => onDelete(item.faqId)} type="submit">
              Hapus
          </Button>
        </div>
      </Modal>
    </>
  );
}
